import { ClientResponse } from './ClientResponse';
export class BlobClientResponse extends ClientResponse {
    constructor(value, statusCode) {
        super(value, statusCode);
    }
}
